<template>
  <Modal class="tablet-h:max-w-[500px]!">
    <Modal.Title>Report an issue</Modal.Title>
    <Modal.Body>
      <ReportFeedbackBody v-model="message" :subject="subject" />
    </Modal.Body>
    <Modal.Footer>
      <Button variant="primary" @click="handleSend">Send</Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { Modal, Button, useModal } from '@dacr/library'
import ReportFeedbackBody from './ReportFeedbackBody.vue'

withDefaults(defineProps<{ subject?: string }>(), { subject: 'report' })

const { close, triggerEvent } = useModal()

const message = ref('')

const handleSend = () => {
  triggerEvent('success', message.value)
  close()
}
</script>
